/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_StarterInputs */

const en_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 credits for EUR 4.99 (one-time payment)`)
};

const de_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 Credits fuer EUR 4,99 (einmalige Zahlung)`)
};

const fr_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter : 25 credits pour EUR 4,99 (paiement unique)`)
};

const es_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 creditos por EUR 4,99 (pago unico)`)
};

const it_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 crediti a EUR 4,99 (pagamento unico)`)
};

const nl_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 credits voor EUR 4,99 (eenmalige betaling)`)
};

const pl_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 kredytow za EUR 4,99 (platnosc jednorazowa)`)
};

const fi_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 krediittiä hintaan EUR 4,99 (kertamaksu)`)
};

const da_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 credits for EUR 4,99 (engangsbetaling)`)
};

const sv_agb_credit_packs_starter = /** @type {(inputs: Agb_Credit_Packs_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter: 25 krediter for EUR 4,99 (engangsbetalning)`)
};

/**
* | output |
* | --- |
* | "Starter: 25 credits for EUR 4.99 (one-time payment)" |
*
* @param {Agb_Credit_Packs_StarterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_starter = /** @type {((inputs?: Agb_Credit_Packs_StarterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_StarterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_starter(inputs)
	if (locale === "fr") return fr_agb_credit_packs_starter(inputs)
	if (locale === "es") return es_agb_credit_packs_starter(inputs)
	if (locale === "it") return it_agb_credit_packs_starter(inputs)
	if (locale === "nl") return nl_agb_credit_packs_starter(inputs)
	if (locale === "pl") return pl_agb_credit_packs_starter(inputs)
	if (locale === "fi") return fi_agb_credit_packs_starter(inputs)
	if (locale === "da") return da_agb_credit_packs_starter(inputs)
	if (locale === "sv") return sv_agb_credit_packs_starter(inputs)
	return en_agb_credit_packs_starter(inputs)
});